import * as React from 'react';
import styled from 'styled-components';
import { DSPaperProps, DSPaper } from '../Paper/DSPaper';
import { DSTypographyProps, DSTypography } from '../Typography';

export const DSWellHeader = styled.div`
    display: flex;
    align-items: center;
`;

export type DSWellHeaderTitleProps = Omit<DSTypographyProps<'h3'>, 'children'> & {
    children?: React.ReactNode;
};

export const DSWellHeaderTitle: React.FC<DSWellHeaderTitleProps> = ({ children, ...rest }) => (
    <DSTypography component="h3" variant="h3" {...rest}>
        {children}
    </DSTypography>
);

export const DSWellHeaderIcon = styled.div`
    min-width: 42px;
`;

export const DSWellHeaderRightContent = styled.span`
    margin-left: auto;
`;

export type DSWellProps = DSPaperProps;

const StyledPaper = styled(DSPaper)`
    padding: 24px;
    margin-bottom: 30px;
`;

export const DSWell: React.FC<DSWellProps> = ({ children, ...rest }) => (
    <StyledPaper elevation={3} {...rest}>
        {children}
    </StyledPaper>
);
DSWell.displayName = 'DSWell';
